import { Check } from '@phosphor-icons/react';
import React from 'react';

interface CheckIconProps {
    className?: string;
    icon?: React.ReactNode;
}

function CheckIcon({ className, icon }: CheckIconProps) {
    return (
        <div
            className={`absolute text-layout-textColorOnPrimary top-2 right-2 h-5 w-5 rounded-full bg-primary ${className}`}
        >
            {icon || <Check className="absolute inset-0 h-3 w-3 m-auto" />}
        </div>
    );
}

export default CheckIcon;
